module.exports = __webpack_public_path__ + "media/images/bronze-medal-840776ceaad62eff8bc399aefdd1e5dd.svg";